import { OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
var PositionBoxComponent = /** @class */ (function () {
    function PositionBoxComponent() {
        this.alignment_options = ['RIGHT', 'LEFT'];
    }
    PositionBoxComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(PositionBoxComponent.prototype, "useDefault", {
        get: function () {
            return this.positionSettings.controls.useDefault.value;
        },
        enumerable: true,
        configurable: true
    });
    PositionBoxComponent.prototype.changeUseDefault = function (useDefault) {
        this.positionSettings.controls.useDefault.setValue(!useDefault);
    };
    return PositionBoxComponent;
}());
export { PositionBoxComponent };
